module.exports = MaterialUI.ExpansionPanel;